"use client";
import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import { Sidebar } from "primereact/sidebar";
import ReactEcharts from "echarts-for-react";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import arrowleft from '../../../assets/images/arrow-left.png';
import arrowright from '../../../assets/images/arrow-right.png';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import StackedBarChart from "../charts/stackedbarchart";
import { fetchAttendance_Dimension_View, fetchAttendance_Rate_Distribution_Dimension, fetchMonthly_Attendance_Dimension } from "../../../redux/slices/attendance";
import { useDispatch, useSelector } from "react-redux";
import LoaderContainer from "../../../components/LoaderContainer/LoaderContainer";

export default function AttendanceSideBar(props) {
    const { visible, onHide, setActiveIndexList, data, DropdownData } = props;
    const [activeTab, setActiveTab] = useState(0);
    const [dropdownData, setDropdownData] = DropdownData;
    const selectedDrpvalue = dropdownData.selectedState;

    /* Redux State */
    const dispatch = useDispatch();
    const Attendance_Dimension_View = useSelector(state => state.attendance.Attendance_Dimension_View);
    const Attendance_Dimension_ViewLoading = useSelector(state => state.attendance.Attendance_Dimension_Viewloading);

    const Attendance_Rate_Distribution_Dimension = useSelector(state => state.attendance.Attendance_Rate_Distribution_Dimension);
    const Attendance_Rate_Distribution_DimensionLoading = useSelector(state => state.attendance.Attendance_Rate_Distribution_Dimensionloading);

    const Monthly_Attendance_Dimension = useSelector(state => state.attendance.Monthly_Attendance_Dimension);
    const Monthly_Attendance_DimensionLoading = useSelector(state => state.attendance.Monthly_Attendance_Dimensionloading);

    const appliedfilter = useSelector(state => state.filter.appliedFilters);  
    /* */

    /* API Call */
    useEffect(() => {
        if (visible) {
            if(data?.[0]?.value?.METRIC_ID != 10011 && data?.[0]?.title != 'Monthly Attendance Rate Trend')
            dispatch(fetchAttendance_Dimension_View({
                "elasticQueryName": "Attendance Dimension View",
                "filters": [{ "columnName": "METRIC_ID", "columnValue": data?.[0]?.value?.METRIC_ID, "excludeKeyword": false }].concat(appliedfilter),
                "dynamicColumns": [
                    { "columnName": "#{dimension}", "columnValue": TabOption[activeTab].code },
                    { "columnName": "#{school_name}", "columnValue": data?.[0]?.value?.METRIC_ID == 10004 ? `and school_official_name in ('${selectedDrpvalue}')` : 'and 1=1' }
                ],
            }));
            if (data?.[0]?.value?.METRIC_ID == 10011) {
                dispatch(fetchAttendance_Rate_Distribution_Dimension({
                    "elasticQueryName": "Attendance Rate Distribution_Dimension",
                    "filters": appliedfilter,
                    "dynamicColumns": [{ "columnName": "#{dimension}", "columnValue": TabOption[activeTab]?.code }],
                }));
            }
            if (data?.[0]?.title == 'Monthly Attendance Rate Trend') {
                dispatch(fetchMonthly_Attendance_Dimension({
                    "elasticQueryName": "Monthly_Attendance_Dimension",
                    "filters": [{ "columnName": "MONTH", "columnValue": selectedDrpvalue, "excludeKeyword": false }].concat(appliedfilter),
                    "dynamicColumns": [
                        { "columnName": "#{dimension}", "columnValue": TabOption[activeTab]?.code },
                    ],
                }));
            }
        }
    }, [visible, activeTab, appliedfilter, selectedDrpvalue])
    /* */

    /* Tab Reset */
    useEffect(() => {
        if (!visible) {
           
        }
    }, [visible]);
    /* */

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    /* Tab Dynamic Title.. */
    const TabOption = {
        0: {name: 'Ethnicity', code: 'student_ethnicity', color: '#EA9E50'},
        1: {name: 'Gender', code: 'student_gender', color: '#F4A950'},
        2: {name: 'School Type', code: 'school_type', color: '#C79B27'},
    }
    /* */

    const EthinicityRates = {
        tooltip: {
            trigger: 'axis',
            valueFormatter: (value) => value ? value?.toFixed(1) +'%' : '-',
            axisPointer: { type: 'shadow' }
        },
        grid: {
            left: '3%',
            right: '0%',
            bottom: '10%',
            top: '5%',
            containLabel: true
        },
        legend: {
            show:false,
            data: ["Ethnicity"],
            bottom: 0,
            left: 0,
            itemGap: 4,
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
                color: '#E0E3E9',
                fontSize: 12
            },
        },
        xAxis: {
            type: 'category',
            // data: [
            //     'Native American',
            //     'American Indian',
            //     'Asian',
            //     'African American',
            //     'Hispanic',
            //     'White'
            // ],
            data: Attendance_Dimension_View?.map(item => item?.DIMENSION),
            axisLabel: { 
                color: "#E0E3E9",
                fontSize: 11,
                formatter: function (value) {
                    const maxLen = 7; // set max length
                    return value.length > maxLen ? value.slice(0, maxLen) + '...' : value;
                }
            },
            name: TabOption[activeTab].name,
            nameLocation: "middle",
            nameGap: 30,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            min: 0,
            max: 100,
            interval: 10,
            axisLabel: {
                color: '#E0E3E9',
                fontSize: 12,
                formatter: '{value}%'
            },
            name: 'Attendance Rate (%)',
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 40,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            splitLine: {
                lineStyle: {
                    color: "#42536D"
                }
            }
        },
        series: [
            {
                name: TabOption[activeTab].name,
                type: 'bar',
                // data: [74, 54.5, 78, 70.2, 80.9, 85.9],
                data: Attendance_Dimension_View?.map(item => item.CURRENT_PERIOD),
                itemStyle: {
                    color: TabOption[activeTab].color
                },
                label: {
                    show: true,
                    position: 'top',
                    formatter: (params) => params.value?.toFixed(1) + '%',
                    color: '#E0E3E9',
                    // formatter: '{c}%'
                }
            }
        ],
    }

    const Attendance_Dimension_ViewOrder = ["0-5 Days", "6-10 Days", "11-15 Days", "More than 16 Days"]
    const option = useMemo(() => {
        let label = new Set();
        const agg = Attendance_Dimension_View.reduce((acc, item) => {
            const { DIMENSION: category, INCIDENT_SUB_TYPE: seriesName } = item;
            if (!acc[seriesName]) {
                acc[seriesName] = {}
            } 
            label.add(category);
            acc[seriesName][category] = item;

            return acc;
        }, {})

        label = [...label]

        for (const seriesName in agg) {
            agg[seriesName] = label.map(category => agg[seriesName]?.[category] ?? {})
        }
        const sortedObject = Object.fromEntries(
            Attendance_Dimension_ViewOrder
                .filter(key => key in agg) // ensure key exists in data
                .map(key => [key, agg[key]])
        );

        return {
            tooltip: {
                trigger: 'axis',
                valueFormatter: (value) => value ? value : '-',
                axisPointer: { type: 'shadow' }
            },
            grid: {
                left: '5%',
                right: '0%',
                bottom: '10%',
                top: '5%',
                containLabel: true
            },
            legend: {
                show: false,
                data: ["School Type"],
                bottom: 0,
                left: 0,
                itemGap: 4,
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {
                    color: '#E0E3E9',
                    fontSize: 12
                },
            },
            xAxis: {
                type: 'category',
                data: label,
                axisLabel: {
                    color: "#E0E3E9",
                    fontSize: 12,
                    hideOverlap: false,
                    interval: 0,
                    width: 60,
                    overflow: 'truncate'
                },
                name: TabOption[activeTab].name,
                nameLocation: "middle",
                nameGap: 30,
                nameTextStyle: {
                    fontSize: 12,
                    color: '#9EA3AA',
                },
                axisTick: {
                    show: false
                },

            },
            yAxis: {
                type: 'value',
                // min: 0,
                // max: 100,
                // interval: 10,
                axisLabel: {
                    color: '#E0E3E9',
                    fontSize: 12,
                    formatter: '{value}'
                },
                name: '# of Students',
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 50,
                nameTextStyle: {
                    fontSize: 12,
                    color: '#9EA3AA',
                },
                splitLine: {
                    lineStyle: {
                        color: "#42536D"
                    }
                }
            },
            color: ['#5470c6', '#91cc75', '#fac858', '#ee6666'],
            series: Object.entries(sortedObject).map(([name, data]) => {
                return {
                    name,
                    type: 'bar',
                    barWidth: '60%',
                    stack: 'stack',
                    data: data.map(row => {
                        return {
                            ...row,
                            value: row?.METRIC_NUMERATOR
                        }
                    }),
                    label: {
                        show: true,
                        position: 'inside',
                        color: '#000',
                        // formatter: '{c}%'
                        formatter: (params) => params?.value < 50 ? '' : params?.value
                    }
                }
            }),
        }
    }, [Attendance_Dimension_View])

    const GenderRates = {
        tooltip: {
            trigger: 'axis',
            valueFormatter: (value) => value ? value?.toFixed(1)+'%' : '-',
            axisPointer: { type: 'shadow' },
        },
        grid: {
            top: '5%',
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true,
        },
        legend: {
            show: false,
            data: ['School Gender'],
            bottom: 0,
            left: 0,
            itemGap: 4,
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
                color: '#E0E3E9',
                fontSize: 12
            },
        },
        xAxis: {
            type: 'category',
            data: Monthly_Attendance_Dimension?.map(item => item?.DIMENSION),
            axisLabel: {
                color: "#E0E3E9",
                fontSize: 12,
                hideOverlap: false,
                interval: 0,
                width: 60,
                overflow: 'truncate'
            },
            name: TabOption?.[activeTab]?.name,
            nameLocation: "middle",
            nameGap: 30,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            min: 0,
            max: 100,
            interval: 10,
            axisLabel: {
                color: '#E0E3E9',
                fontSize: 12,
                formatter: '{value}%'
            },
            name: 'Attendance Rate (%)',
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 40,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            splitLine: {
                lineStyle: {
                    color: "#42536D"
                }
            }
        },
        series: [
            {
                name: 'Proficiency',
                type: 'bar',
                data: Monthly_Attendance_Dimension?.map(item => item?.ATTENDANCE_RATE),
                label: {
                    show: true,
                    position: 'top',
                    // formatter: '{c}%',
                    formatter: (params) => params.value?.toFixed(1) + '%',
                    color: '#fff',
                },
                itemStyle: {
                   color: TabOption[activeTab].color 
                },
            },
        ],
    }

    const CustChart = React.memo(({ options }) => {
        return <ReactEcharts option={options} style={{ width: '100%', height: '100%' }} />;
    });


    return(
        <>
            <Sidebar
                visible={visible}
                onHide={() => {
                    onHide();
                    setActiveTab(0);
                    setDropdownData({selectedState: "", option: []});
                }}
                position="right"
                className="custmSidebar 2xl:w-[18.75vw] bg-[#15181F]"
                blockScroll={true}
            >
                <div className="p-[20px]">
                    <div className="text-[#F2F2F5] text-[16px] pb-5">Dimension View</div>
                    <div className="bg-[#272321e6] rounded-[6px] mt-5 border border-[#ffffff1a]">
                        <div className="px-3 py-2 text-[16px] text-[#fff] font-medium border-b border-[#ffffff1a]">{TabOption[activeTab].name} - {data?.[0]?.title}</div>
                        <div className="px-4 mb-2">
                            <Tabs selectedIndex={activeTab} onSelect={handleTabClick}>
                                <TabList>
                                    <div className="flex justify-between">
                                        <div className="flex items-center mb-1">
                                            <Tab>
                                                <div className={`${activeTab === 0 ? " bg-[#4c3428]" : " bg-[#141110]"} text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-bl-[5px] cursor-pointer `}>Ethnicity</div>
                                            </Tab>
                                            <Tab>
                                                <div className={`${activeTab === 1 ? " bg-[#4c3428]" : " bg-[#141110]"} text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] cursor-pointer `}>Gender</div>
                                            </Tab>
                                            <Tab>
                                                <div className={`${activeTab === 2 ? " bg-[#4c3428]" : " bg-[#141110]"} text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-br-[5px] cursor-pointer `}>School Type</div>
                                            </Tab>
                                        </div>
                                        {(data?.[0]?.value?.METRIC_ID == 10004 || data?.[0]?.value?.METRIC_ID == 10004) &&  
                                        <Dropdown
                                            inputId="fruit"
                                            value={selectedDrpvalue}
                                            onChange={(e) => setDropdownData(prev => ({...prev, selectedState: e.value}))}
                                            options={dropdownData.option}
                                            placeholder="Select a Value"
                                            className="side_drop"
                                            panelClassName="customdrop"
                                        />}
                                    </div>
                                </TabList>
                                {data?.[0]?.value?.METRIC_ID == 10011 ?
                                    <div className="h-[420px]">
                                        <LoaderContainer loading={Attendance_Rate_Distribution_DimensionLoading} height={'100%'} width={'100%'}>
                                            <StackedBarChart
                                                grid={{
                                                    left: "2%",
                                                    right: "0%",
                                                    bottom: "0%",
                                                    top: "3%",
                                                    width: '100%',
                                                    height: '100%',
                                                    containLabel: true
                                                }}
                                                legend={{
                                                    data: ['<90%', '90%-94%', '>95%'],
                                                    bottom: 0,
                                                    left: 'start',
                                                    padding: [0, 0, 0, 10],
                                                    itemGap: 4,
                                                    itemWidth: 7,
                                                    itemHeight: 7,
                                                    textStyle: {
                                                        color: '#E0E3E9',
                                                        fontSize: 10
                                                    },
                                                }}
                                                xAxisData={{
                                                    show: false,
                                                    type: "value",
                                                    // max: 100,
                                                    axisLine: { show: false },
                                                    splitLine: { show: false },
                                                }}
                                                yAxisData={{
                                                    type: "category",
                                                    inverse: true,
                                                    // data: [
                                                    //     'Pre-K', 'KG', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'
                                                    //   ],
                                                    data: Attendance_Rate_Distribution_Dimension?.map(item => item?.DIMENSION),
                                                    axisLabel: {
                                                        show: true,
                                                        color: "#E0E3E9",
                                                        fontSize: 12,
                                                    },
                                                    axisLine: { show: false },
                                                    splitLine: { show: false },
                                                    axisTick: { show: false },
                                                }}
                                                series={[
                                                    {
                                                        name: "<90%",
                                                        type: "bar",
                                                        stack: "total",
                                                        label: {
                                                            show: true,
                                                            position: 'inside',
                                                            color: "#fff",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            // formatter: "{c}%"
                                                            formatter: (params) => params?.value < 2 ? '' : (params?.value?.toFixed(1) + '%'),
                                                        },
                                                        itemStyle: {
                                                            color: "#B65D59",
                                                            borderRadius: [0, 0, 0, 0],
                                                        },
                                                        // data: [65, 58, 67, 60, 66, 65, 66, 65, 56, 62, 66, 66, 65, 68],
                                                        data: Attendance_Rate_Distribution_Dimension?.map(item => item?.PCT_BELOW_90),
                                                    },
                                                    {
                                                        name: "90%-94%",
                                                        type: "bar",
                                                        stack: "total",
                                                        label: {
                                                            show: true,
                                                            position: "inside",
                                                            color: "#fff",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            // formatter: "{c}%"
                                                            formatter: (params) => params?.value < 2 ? '' : (params?.value?.toFixed(1) + '%'),
                                                        },
                                                        itemStyle: {
                                                            color: "#C79B27"
                                                        },
                                                        // data: [24, 27, 21, 17, 17, 22, 22, 21, 20, 25, 20, 20, 22, 20],
                                                        data: Attendance_Rate_Distribution_Dimension?.map(item => item?.PCT_90_94),
                                                    },
                                                    {
                                                        name: ">95%",
                                                        type: "bar",
                                                        stack: "total",
                                                        label: {
                                                            show: true,
                                                            position: "inside",
                                                            color: "#fff",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            // formatter: "{c}%"
                                                            formatter: (params) => params?.value < 2 ? '' : (params?.value?.toFixed(1) + '%'),
                                                        },
                                                        itemStyle: {
                                                            color: "#129C83",
                                                            borderRadius: [0, 5, 5, 0],
                                                        },
                                                        //   data: [11, 15, 15, 23, 17, 27, 12, 14, 24, 13, 14, 14, 13, 12],
                                                        data: Attendance_Rate_Distribution_Dimension?.map(item => item?.PCT_ABOVE_95),
                                                    }
                                                ]}
                                            />
                                        </LoaderContainer>
                                    </div>
                                    : data?.[0]?.value?.METRIC_ID == 10008 ?
                                    <div className="h-[400px]">
                                        <LoaderContainer loading={Attendance_Dimension_ViewLoading} height={'100%'} width={'100%'}>
                                            <CustChart options={option} />
                                        </LoaderContainer>
                                    </div>
                                    : data?.[0]?.title == 'Monthly Attendance Rate Trend'?
                                    <div className="h-[400px] mt-2">
                                        <LoaderContainer loading={Monthly_Attendance_DimensionLoading} height={'100%'} width={'100%'}>
                                            <CustChart options={GenderRates} />
                                        </LoaderContainer>
                                    </div>
                                    :
                                    <div className="h-[400px] mt-2">
                                        <LoaderContainer loading={Attendance_Dimension_ViewLoading} height={'100%'} width={'100%'}>
                                            <CustChart options={EthinicityRates} />
                                        </LoaderContainer>
                                    </div>
                                }
                            </Tabs>
                        </div>
                    </div>
                </div>
            </Sidebar>
        </>
    )
}